import { Label } from "../ui/label";
import { Button } from "../ui/button";
import LoadingButton from "../LoadingButton";
import { Input } from "../ui/input";
import { useState } from "react";
import {
  Toast,
  ToastDescription,
  ToastTitle,
  ToastViewport,
} from "../ui/toast";

const API_URL = process.env.REACT_APP_API_URL; // Ensure this matches your backend URL

const AssignRole = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [toastList, setToastList] = useState([]);

  const username = process.env.REACT_APP_API_USERNAME;
  const password = process.env.REACT_APP_API_PASSWORD;
  const credentials = `${username}:${password}`;
  const encodedCredentials = btoa(credentials); // Base64 encode the credentials

  const [userDetails, setUserDetails] = useState({
    userEmail: "",
    role: "",
  });

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setUserDetails((prev) => ({
      ...prev,
      [id]: value, // Dynamically update the corresponding key
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);

    try {
      const token = localStorage.getItem("x-auth-token");
      //   console.log(token);
      const response = await fetch(`${API_URL}/api/role/assign-role`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${encodedCredentials}`, // Basic Auth header
          "x-auth-token": token,
        },
        body: JSON.stringify(userDetails),
      });

      const responseData = await response.json();

      if (response.ok) {
        setToastList((prev) => [
          ...prev,
          {
            id: Date.now(),
            title: "SUCCESS!",
            description: responseData.message || "!",
            variant: "default",
          },
        ]);

        setIsLoading(false);
      } else {
        setToastList((prev) => [
          ...prev,
          {
            id: Date.now(),
            title: "SUCCESS!",
            description: responseData.message || "!",
            variant: "default",
          },
        ]);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error assigning role:", error);
      setIsLoading(false);
    }
  };

  const removeToast = (id) => {
    setToastList((prev) => prev.filter((toast) => toast.id !== id));
  };

  return (
    <main className="tw-p-8">
      <form onSubmit={handleSubmit}>
        <div className="tw-grid tw-grid-cols-1 tw-gap-6 md:tw-gap-8">
          <div className="tw-grid tw-gap-2">
            <Label className="tw-font-medium" htmlFor="userEmail">
              User Email
            </Label>
            <Input
              className="placeholder:tw-text-[#828282]/50 placeholder:tw-text-xs tw-bg-white placeholder:md:tw-text-sm"
              id="userEmail"
              type="email"
              value={userDetails.userEmail}
              onChange={handleInputChange}
              placeholder="Enter email address"
              required
            />
          </div>
          <div className="tw-grid tw-gap-2">
            <Label className="tw-font-medium" htmlFor="role">
              Role
            </Label>
            <div className="tw-relative tw-flex tw-items-center">
              <Input
                className="placeholder:tw-text-[#828282]/50 placeholder:tw-text-xs tw-bg-white placeholder:md:tw-text-sm tw-pr-10"
                id="role"
                type="text"
                value={userDetails.role}
                onChange={handleInputChange}
                placeholder="Enter role"
                required
              />
            </div>
          </div>
        </div>

        {isLoading ? (
          <LoadingButton />
        ) : (
          <Button
            type="submit"
            className="tw-w-full tw-font-semibold tw-mt-6 md:tw-mt-8 tw-text-sm"
          >
            ASSIGN ROLE
          </Button>
        )}
      </form>

      {/* Toast Notifications */}
      <ToastViewport />
      {toastList.map(({ id, title, description, variant }) => (
        <Toast
          key={id}
          variant={variant}
          open={true}
          duration={Infinity}
          onOpenChange={(isOpen) => {
            if (!isOpen) removeToast(id);
          }}
          className="tw-flex tw-flex-col tw-text-center"
        >
          <ToastTitle>{title}</ToastTitle>
          <ToastDescription>{description}</ToastDescription>

          {/* Close Button */}
          <button
            onClick={() => removeToast(id)}
            className="tw-mt-3 tw-self-center tw-text-sm tw-font-medium tw-bg-white tw-px-2 tw-py-1 tw-text-black hover:tw-bg-white/80"
          >
            Close
          </button>
        </Toast>
      ))}
    </main>
  );
};

export default AssignRole;
